import { render, staticRenderFns } from "./TocList.vue?vue&type=template&id=3bb17f1e&scoped=true"
import script from "./TocList.vue?vue&type=script&lang=js"
export * from "./TocList.vue?vue&type=script&lang=js"
import style0 from "./TocList.vue?vue&type=style&index=0&id=3bb17f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb17f1e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TocList: require('/workspace/components/TocList.vue').default})
